// Auth API client — FE-A.

import { api } from "@/api/client";

import type {
  AuthMeResponse,
  AuthSession,
  AuthSessionsResponse,
  LoginRequest,
  LoginResponse,
  LogoutAllResponse,
  RevokeSessionResponse,
  SignupRequest,
  SignupResponse,
} from "./types";

export function login(body: LoginRequest): Promise<LoginResponse> {
  return api.post<LoginResponse>("/api/v1/auth/login", body);
}

export function signup(body: SignupRequest): Promise<SignupResponse> {
  return api.post<SignupResponse>("/api/v1/auth/signup", body);
}

export function logout(): Promise<void> {
  return api.post<void>("/api/v1/auth/logout");
}

// Auth-02: revoke every session for the caller. The current cookie
// is cleared in the response; the FE caller is responsible for
// running its own auth-lost cleanup (clearing query cache, routing
// to /login).
export function logoutAll(): Promise<LogoutAllResponse> {
  return api.post<LogoutAllResponse>("/api/v1/auth/logout-all");
}

export function listSessions(opts?: {
  signal?: AbortSignal;
}): Promise<AuthSessionsResponse> {
  return api.get<AuthSessionsResponse>("/api/v1/auth/sessions", opts);
}

export function revokeSession(
  sessionId: string,
): Promise<RevokeSessionResponse> {
  return api.post<RevokeSessionResponse>(
    `/api/v1/auth/sessions/${sessionId}/revoke`,
  );
}

export function me(opts?: { signal?: AbortSignal }): Promise<AuthMeResponse> {
  return api.get<AuthMeResponse>("/api/v1/auth/me", opts);
}

export type { AuthSession };

// Re-export so AuthProvider can drive a proactive refresh interval
// without reaching across module layers.
export { refreshSession } from "@/api/client";
